module.exports = __webpack_public_path__ + "images/c54471a.svg";